"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePowerBiReportClient = usePowerBiReportClient;
const PowerBiReportClient_1 = require("@juvare/platform-sdk-js/PowerBiReportClient");
const react_1 = __importDefault(require("react"));
function usePowerBiReportClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new PowerBiReportClient_1.PowerBiReportClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
